import { useState, useEffect, startTransition } from "react";
const useIsSsr = () => {
  const [isServer, setIsServer] = useState(true);
  useEffect(() => {
    startTransition(() => {
      setIsServer(false);
    });
  }, []);
  return isServer;
};
export {
  useIsSsr
};
